<div
  class="flex min-w-[512px] flex-col gap-4 rounded-[48px] border-2 border-background-white bg-background-modal px-6 pb-4 pt-6 backdrop-blur"
>
  <span class="typo-h2">
    {{ 'complete_appointment_modal_title' | translate }}
  </span>
  <div class="flex items-center gap-4 px-3 py-1.5">
    @if (dialogData.selectedPatient) {
      <lib-avatars [persons]="[dialogData.selectedPatient]" [size]="44" />
      <div class="flex h-full flex-col gap-1 text-left">
        <div class="typo-h5-semibold flex flex-1 items-end text-text-primary">
          {{ dialogData.selectedPatient.firstName }} {{ dialogData.selectedPatient.lastName }}
        </div>
        <div class="typo-h5-medium text-text-secondary">
          {{ dialogData.appointmentDate | date: 'MM/dd/yyyy' }}
        </div>
      </div>
    }
  </div>
  <div class="flex flex-col">
    <div class="flex items-center gap-[22px] rounded-[20px] border-2 border-solid border-transparent px-4 py-4">
      <div class="flex max-w-[580px] items-center gap-[22px]">
        <lib-checkbox [checked]="isAllSelected()" (click)="toggleSelectAll()"></lib-checkbox>
        <span class="typo-h5-light text-text-primary">{{ 'complete_appointment_modal_procedures_select_all' | translate }}</span>
      </div>
    </div>
    <div class="relative flex max-h-72 w-[786px] flex-col justify-start">
      <div #scrollContainer class="flex h-full flex-col gap-4 overflow-y-scroll rounded-[20px]">
        @for (item of treatments(); track getTreatmentKey(item)) {
          <lib-treatment-item-pill
            [treatment]="item"
            [checked]="isItemSelected()(item)"
            [showValidationError]="attemptedSubmit()"
            (treatmentClicked)="openRequiredInputModal(item, $event.isSurface, $index)"
            (treatmentChecked)="onItemChecked(item)"
          ></lib-treatment-item-pill>
        }
      </div>
      <div
        #bottomGradient
        [ngClass]="{
          hidden: scrollContainer.offsetHeight === scrollContainer.scrollHeight
        }"
        class="pointer-events-none absolute bottom-0 left-0 right-0 z-10 h-14 rounded-b-[20px] bg-gradient-to-t from-background-white to-transparent transition-opacity duration-150"
      ></div>
    </div>
  </div>
  @if (attemptedSubmit() && hasValidationError()) {
    <div class="flex justify-end px-4 text-h5 text-states-red">
      Please add input for each selected procedure or deselect procedures without inputs.
    </div>
  }
  <div class="flex justify-between gap-2">
    <button type="button" class="btn-text" (click)="closeDialog()">{{ 'complete_appointment_modal_cancel_button' | translate }}</button>
    <div class="flex gap-2">
      <button type="button" class="btn-secondary" (click)="completeAppointment(true)">
        {{ 'complete_appointment_modal_skip_button' | translate }}
      </button>
      <button type="button" class="btn-primary" (click)="completeAppointment()">
        {{ 'complete_appointment_modal_set_complete_button' | translate }}
      </button>
    </div>
  </div>
</div>
